"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TWFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_235)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_235`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.47998 0.000244141H35.5201V23.9998H-0.47998V0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.47998 0.000244141H17.52V12H-0.47998V0.000244141Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.6287 6.00009L10.9498 6.78977L11.8438 8.41575L10.0208 8.06693L9.78974 9.90855L8.51997 8.55412L7.25012 9.90855L7.01915 8.06693L5.19615 8.41568L6.09011 6.7897L4.41125 6.00009L6.09011 5.21041L5.19615 3.58443L7.01915 3.93318L7.2502 2.09155L8.51997 3.44598L9.78981 2.09155L10.0208 3.93318L11.8439 3.58443L10.9498 5.21041L12.6287 6.00009Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.51995 8.03991C9.64633 8.03991 10.5594 7.1268 10.5594 6.00042C10.5594 4.87405 9.64633 3.96094 8.51995 3.96094C7.39358 3.96094 6.48047 4.87405 6.48047 6.00042C6.48047 7.1268 7.39358 8.03991 8.51995 8.03991Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.52005 7.36358C7.76827 7.36358 7.15662 6.75186 7.15662 6.00015C7.15662 5.24837 7.76834 4.63672 8.52005 4.63672C9.27183 4.63672 9.88348 5.24844 9.88348 6.00015C9.88348 6.75186 9.27183 7.36358 8.52005 7.36358Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_235`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TWFlag };
